class MessageRequestRequest {
  static create = {
    messageRequestFrom: null,
    messageRequestTo: null,
    messageRequestBody: null
  };
  static accept = {
    messageGroupId: null
  };

  static decline = {
    messageGroupId: null
  };

  static readBy = {
    messageRequestId: null
  };

  static readPending = {
    customerId: null
  };
  static createMessage = {
    messageGroupId: null,
    messageFrom: null,
    messageTo: null,
    messageBody: null
  };
}

export default MessageRequestRequest;
